import type React from "react";
import { useState, useEffect } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";

import { toast } from "react-toastify";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import DynamicTable from "../../../components/Dynamic-table";

// "D:\new clone pk-hims\hims-frontend\public\thermal-printer-icon.png"

const AvailableStock = () => {
  const [loading, setLoading] = useState(true);
  const [crossMatch, setAllCrossMatch] = useState<any[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [stock, setStock] = useState<any[]>([]);

  // Fetch blood bags data from API
  useEffect(() => {
    fetchStock();
  }, []);

  const fetchStock = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/getAvailableStockState`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data?.data) {
        console.log("All Cross Match Data:", response.data.data);
        setStock(response.data.data);
      } else {
        toast.error("No cross matches found");
        setStock([]);
      }
    } catch (error) {
      console.error("Error fetching cross matches:", error);
      toast.error("Failed to fetch cross matches");
      setStock([]);
    } finally {
      setLoading(false);
    }
  };
  //     const checkForNewCrossMatch = async () => {
  //       const newlyAddedCrossMatch = localStorage.getItem("newlyAddedCrossMatch");
  //       if (newlyAddedCrossMatch && !loading) {
  //         try {
  //           const parsedData = JSON.parse(newlyAddedCrossMatch);
  //           console.log("Found newly added cross match:", parsedData);

  //           const matchIndex = crossMatch.findIndex(
  //             (item) =>
  //               item.bagNo === parsedData.bagNo &&
  //               item.slipNo === parsedData.slipNo
  //           );

  //           if (matchIndex === -1) {
  //             console.log(
  //               "Cross match not found in loaded data, using stored data for printing"
  //             );
  //             const printNewCrossMatch = () => {
  //               const performerName =
  //                 parsedData.performedBy ||
  //                 profile?.data?.fullName ||
  //                 profile?.data?.firstName ||
  //                 "";
  //               const doc = generateCrossMatchPDF(
  //                 parsedData,
  //                 formatDate,
  //                 performerName
  //               );

  //               if (!doc) {
  //                 toast.error("Failed to generate PDF");
  //                 return;
  //               }

  //               const pdfBlob = doc.output("blob");
  //               const blobUrl = URL.createObjectURL(pdfBlob);

  //               const iframe = document.createElement("iframe");
  //               iframe.style.display = "none";
  //               document.body.appendChild(iframe);

  //               iframe.onload = () => {
  //                 try {
  //                   setTimeout(() => {
  //                     if (iframe.contentWindow) {
  //                       iframe.contentWindow.focus();
  //                       iframe.contentWindow.print();

  //                       iframe.contentWindow.onafterprint = () => {
  //                         document.body.removeChild(iframe);
  //                         URL.revokeObjectURL(blobUrl);
  //                       };
  //                     }
  //                   }, 1000);
  //                 } catch (e) {
  //                   console.error("Error triggering print:", e);
  //                   window.open(blobUrl, "_blank");
  //                   URL.revokeObjectURL(blobUrl);
  //                 }
  //               };

  //               iframe.src = blobUrl;

  //               const backupCleanupTimer = setTimeout(() => {
  //                 try {
  //                   if (document.body.contains(iframe)) {
  //                     document.body.removeChild(iframe);
  //                     URL.revokeObjectURL(blobUrl);
  //                   }
  //                 } catch (e) {
  //                   console.error("Error during backup cleanup:", e);
  //                 }
  //               }, 100000);
  //             };
  //             setTimeout(printNewCrossMatch, 1000);
  //           } else {
  //             console.log(
  //               "Found cross match in loaded data at index:",
  //               matchIndex
  //             );
  //             setTimeout(() => {
  //               handlePrint(matchIndex);
  //               navigate("/cross-match-report");
  //             }, 1000);
  //           }

  //           localStorage.removeItem("newlyAddedCrossMatch");
  //         } catch (error) {
  //           console.error("Error processing newly added cross match:", error);
  //           localStorage.removeItem("newlyAddedCrossMatch");
  //         }
  //       }
  //     };
  //     if (!loading) {
  //       checkForNewCrossMatch();
  //     }
  //   }, [crossMatch, loading]);

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ background: "#fff", p: 2, borderRadius: "8px", mb: 0.5 }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
          Available Stock
        </Typography>
      </Box>
      <Paper sx={{ p: 1, borderRadius: "8px" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <>
            <DynamicTable
              headers={["SN", "B.G", "Count", "PRC","FFP","PLT", "Cryo", "W.Blood", 'Other']}
              data={stock?.map((item: any, idx: any) => {
                return [
                  idx + 1,
                  item?.bloodGroup,
                  item?.count,
                   item?.PRC.count>0?`${item?.PRC.count} (${item?.PRC?.bagNos.join(", ")})`:item?.PRC?.count,
                   item?.FFP.count>0?`${item?.FFP.count} (${item?.FFP?.bagNos.join(", ")})`:item?.FFP?.count,
                   item?.PLT.count>0?`${item?.PLT.count} (${item?.PLT?.bagNos.join(", ")})`:item?.PLT?.count,
                   item?.Cryo.count>0?`${item?.Cryo.count} (${item?.Cryo?.bagNos.join(", ")})`:item?.Cryo?.count,
                   item?.WB.count>0?`${item?.WB.count} (${item?.WB?.bagNos.join(", ")})`:item?.WB?.count,
                   item?.Other.count>0?`${item?.Other.count} (${item?.Other?.bagNos.join(", ")})`:item?.Other.count,
                  
                  // ` ${
                  //   item?.bagNos?.length > 0 ? item.bagNos.join(", ") : "------"
                  // }`,
                ];
              })}
              loading={false}
            />
          </>
        )}
      </Paper>
    </Box>
  );
};

export default AvailableStock;
